import Vue from 'vue'
import VueResource from 'vue-resource'
import cookieapp from '../components/kokuapp/cookieApp.vue'

Vue.use(VueResource)

export default () => {
  /* eslint-disable no-new */
  window.orCookieApp = new Vue({
    el: '#form-client-cookies',
    components: { cookieapp },
    template: '<cookieapp/>',
    methods: {
      showapp: function () {
        this.$broadcast('show-app')
      }
    }
  })
}




// WEBPACK FOOTER //
// ./src/lib/kokuapp-shared-instance.js